import React from "react";

import { Route } from "react-router-dom";

import lazyWithRetry from "helpers/lazyWithRetry";

const NPSPage = lazyWithRetry(() => import("./NPSPage"));

export default [
  <Route exact path="/settings/nps" key="nps-statistics" component={NPSPage} />,
];
